import React, { useState } from "react";
import InputFactory from "../../../../components/InputFactory";

function DialogCreate({
  schema,
  schemas,
  objects,
  onChangeData,
  handleSubmit,
  handleClose,
}) {
  const [location, setLocation] = useState(false);
  const [invalidFields, setInvalidFields] = useState([]);
  const [hasQueue, setHasQueue] = useState(false);
  const [windowOptions, setWindowOptions] = useState([]);
  const [isSubmitting, setSubmitting] = useState(false);

  function handleChange(value, field) {
    if (field === "roles" && value.name === "Coordinator") {
      setLocation(true);
    } else if (field === "roles") {
      setLocation(false);
    }
    if (field === "roles") {
      switch (value.name) {
        case "Recruiter":
          setWindowOptions([
            "Counter 1",
            "Counter 2",
            "Counter 3",
            "Counter 4",
            "Counter 5",
            "Counter 6",
            "Counter 7",
          ]);
          setHasQueue(true);
          break;
        case "Accounting":
        case "HR":
        case "Admin":
          setWindowOptions([
            "Resignation",
            "Final Pay",
            "Orientation",
            "COE",
            "Others",
          ]);
          setHasQueue(true);
          break;
        default:
          setHasQueue(false);
      }
    }
    setInvalidFields((prev) =>
      prev.filter((invalidField) => invalidField !== field)
    );

    onChangeData(value, field);
  }

  async function validateAndSubmit() {
    const requiredFields = ["employee", "username", "roles"];
    if (!objects?.id) {
      requiredFields.push("password");
    }
    if (location || objects?.location?.name) {
      requiredFields.push("location", "clients");
    }
    if (hasQueue === true) {
      requiredFields.push("window");
    }

    const missingFields = requiredFields.filter(
      (field) =>
        !objects?.[field] ||
        (typeof objects[field] === "string" && objects[field].trim() === "")
    );

    if (missingFields.length > 0) {
      setInvalidFields(missingFields);
      return;
    }
    setSubmitting(true);

    try {
      const result = await handleSubmit();
      if (!result) setSubmitting(false);
    } catch (err) {
      setSubmitting(false);
    }
  }
  console.log(objects);

  return (
    <>
      <div
        className="p-4 rounded"
        style={{ maxWidth: "450px", margin: "auto" }}
      >
        <div
          className="d-flex align-items-center mb-3"
          style={{ color: "#d18237" }}
        >
          <div
            className="bg-light p-3 rounded-circle d-flex justify-content-center align-items-center"
            style={{ width: "50px", height: "50px" }}
          >
            <i className="bi bi-person fs-4"></i>
          </div>
          <h5 className="fw-bold ms-2">
            {objects?.id !== "" ? "Edit User" : "Create User"}
          </h5>
        </div>

        {objects?.roles && objects?.roles.id !== "Applicants" ? (
          <div className="mb-3">
            <label className="form-label fw-bold">
              Select Employee
              <span className="text-danger ms-1 fw-lighter">*</span>
            </label>
            <InputFactory
              type="Pointer"
              target="employees"
              field="employee"
              schemas={schemas}
              onChange={(value, field) => handleChange(value, field)}
              placeholder="Select Employee"
              required={true}
              defaultValue={objects?.employee}
              className={invalidFields.includes("employee") ? "is-invalid" : ""}
            />
          </div>
        ) : (
          ""
        )}

        <div className="mb-3">
          <label className="form-label fw-bold">
            Username<span className="text-danger ms-1 fw-lighter">*</span>
          </label>
          <InputFactory
            type="String"
            field="username"
            onChange={(value, field) => handleChange(value, field)}
            placeholder="Enter username"
            defaultValue={objects?.username}
            className={invalidFields.includes("username") ? "is-invalid" : ""}
          />
        </div>

        <div className="mb-4">
          <label className="form-label fw-bold">
            Password
            {objects?.id !== "" ? (
              ""
            ) : (
              <span className="text-danger ms-1 fw-lighter">*</span>
            )}
          </label>
          <InputFactory
            type="Password"
            field="password"
            transform="md5"
            onChange={(value, field) => handleChange(value, field)}
            placeholder="Enter password"
            className={invalidFields.includes("password") ? "is-invalid" : ""}
          />
        </div>

        <div className="mb-4">
          <label className="form-label fw-bold">
            Roles<span className="text-danger ms-1 fw-lighter">*</span>
          </label>
          <InputFactory
            type="Pointer"
            target="roles"
            schemas={schemas}
            disabled={objects?.roles.id === "Applicants"}
            field="roles"
            onChange={(value, field) => handleChange(value, field)}
            placeholder="Select Role"
            defaultValue={objects?.roles || undefined}
            className={invalidFields.includes("roles") ? "is-invalid" : ""}
          />
        </div>
        {hasQueue || objects?.roles.id === "Recruiter" ? (
          <div className="mb-3">
            <label className="form-label fw-bold">
              Window Name<span className="text-danger ms-1 fw-lighter">*</span>
            </label>
            <InputFactory
              type="Enum"
              field="window"
              options={windowOptions}
              schemas={schemas}
              onChange={(value, field) => handleChange(value, field)}
              placeholder="Enter Window Name"
              defaultValue={objects?.window || ""}
              className={invalidFields.includes("window") ? "is-invalid" : ""}
            />
          </div>
        ) : (
          ""
        )}

        {/* {(location || objects?.location?.name) && (
          <div className="mb-4">
            <label className="form-label fw-bold">
              Location<span className="text-danger ms-1 fw-lighter">*</span>
            </label>
            <InputFactory
              type="Pointer"
              target="locations"
              schemas={schemas}
              field="location"
              onChange={(value, field) => handleChange(value, field)}
              placeholder="Enter location"
              defaultValue={objects?.location}
              className={invalidFields.includes("location") ? "is-invalid" : ""}
            />
          </div>
        )}

        {(location || objects?.location?.name) && (
          <div className="mb-4">
            <label className="form-label fw-bold">
              Clients<span className="text-danger ms-1 fw-lighter">*</span>
            </label>
            <InputFactory
              type="Relation"
              target="clients"
              schemas={schemas}
              field="clients"
              onChange={(value, field) => handleChange(value, field)}
              placeholder="Enter location"
              defaultValue={objects?.clients}
              className={invalidFields.includes("clients") ? "is-invalid" : ""}
            />
          </div>
        )} */}

        {objects?.roles.id === "Coordinator" && (
          <div className="mb-4">
            <label className="form-label fw-bold">
              Location<span className="text-danger ms-1 fw-lighter">*</span>
            </label>
            <InputFactory
              type="Pointer"
              target="locations"
              schemas={schemas}
              field="location"
              onChange={(value, field) => handleChange(value, field)}
              placeholder="Enter location"
              defaultValue={objects?.location}
              className={invalidFields.includes("location") ? "is-invalid" : ""}
            />
          </div>
        )}

        {objects?.roles.id === "Coordinator" && (
          <div className="mb-4">
            <label className="form-label fw-bold">
              Clients<span className="text-danger ms-1 fw-lighter">*</span>
            </label>
            <InputFactory
              type="Relation"
              target="clients"
              schemas={schemas}
              field="clients"
              onChange={(value, field) => handleChange(value, field)}
              placeholder="Enter location"
              defaultValue={objects?.clients}
              className={invalidFields.includes("clients") ? "is-invalid" : ""}
            />
          </div>
        )}

        <div className="d-flex justify-content-center">
          <button
            disabled={isSubmitting}
            className="btn text-white me-2 px-4"
            style={{ backgroundColor: "#d18237" }}
            onClick={async () => await validateAndSubmit()}
          >
            {isSubmitting
              ? "Submitting..."
              : objects?.id
              ? "Update"
              : "Confirm"}
          </button>
          <button
            className="btn px-4"
            onClick={() => handleClose()}
            style={{ backgroundColor: "#d0d0d0" }}
          >
            Cancel
          </button>
        </div>
      </div>
    </>
  );
}

export default DialogCreate;
